import { env } from 'next-runtime-env';

export const NEXT_PUBLIC_API_URL = env('NEXT_PUBLIC_API_URL');
export const NEXT_PUBLIC_WEB_URL = env('NEXT_PUBLIC_WEB_URL');
export const NEXT_PUBLIC_TOSS_UI_WIDGET_KRW_VARIANT_KEY = env(
  'NEXT_PUBLIC_TOSS_UI_WIDGET_KRW_VARIANT_KEY',
);
export const NEXT_PUBLIC_TOSS_UI_WIDGET_USD_VARIANT_KEY = env(
  'NEXT_PUBLIC_TOSS_UI_WIDGET_USD_VARIANT_KEY',
);
export const NEXT_PUBLIC_TOSS_PAYMENT_CLIENT_KEY = env('NEXT_PUBLIC_TOSS_PAYMENT_CLIENT_KEY');
export const NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY = env('NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY');
export const NEXT_PUBLIC_HCAPTCHA_SITE_KEY = env('NEXT_PUBLIC_HCAPTCHA_SITE_KEY');
